import { get, isEmpty } from 'ravenjs/utils/lodash';
import { SKU_TYPES } from 'constants/skus';
import _sortBy from 'lodash/sortBy';
import _forEach from 'lodash/forEach';
/**
 * Filter the given list of skus to remove any `skuType` of 'SYSTEM'
 *
 * @method filterSystemSkusFromList
 * @param  {Array}                   list List of SKUs to filter
 * @return {Array}
 */
export const filterSystemSkusFromList = (list = []) =>
    list.filter(item => item.type !== SKU_TYPES.SYSTEM);

/**
 * Sort the given list of skus
 *
 * @method sortSkuList
 * @param  {Array}                   list List of SKUs to sort
 * @return {Array}
 */

export const sortSkuList = skuList => {
    return _sortBy(skuList, sku => {
        return sku.name.toLowerCase();
    });
};
/**
 * Format SKU details
 *
 * @param   {Object}    sku
 * @return  {Object}
 */
export const formatSKUDetails = sku => {
    const {
        description,
        id,
        isActive,
        isPartnerOnly,
        key,
        type,
        learnPackageId,
        mdlPackageMaster,
        name,
        permissions = [],
    } = sku;
    const learnPackageName = get(mdlPackageMaster, 'name', '-');

    return {
        info: [
            {
                title: 'SKU ID',
                value: id,
            },
            {
                title: 'SKU Name',
                value: name,
            },
            {
                title: 'SKU Key',
                value: key,
            },
            {
                title: 'SKU Type',
                value: type,
            },
            {
                title: 'Description',
                value: description || '-',
            },
            {
                title: 'Active',
                value: isActive ? 'YES' : 'NO',
            },
            {
                title: 'Partner Only',
                value: isPartnerOnly ? 'YES' : 'NO',
            },
            {
                title: 'Is Learn Package',
                value: learnPackageId ? 'YES' : 'NO',
            },
            {
                title: 'Learn Package',
                value: learnPackageName,
            },
        ],
        permissions,
    };
};

export const getSponsorshipsSkus = companySkus => {
    const sponsorships = [];
    const indexNotAllowed = [];

    _forEach(companySkus, (item, index) => {
        if (indexNotAllowed.indexOf(index) === -1) {
            const findRepeated =
                item.configurationType !== 'alternate' &&
                companySkus.find((el, indexF) => {
                    const found = indexF > index && el.id === item.id;
                    if (found) {
                        indexNotAllowed.push(indexF);
                    }
                    return found;
                });

            if (
                isEmpty(findRepeated) &&
                item.sponsorBy &&
                !sponsorships.find(row => row.id === item.id)
            ) {
                sponsorships.push(item);
            } else if (
                !isEmpty(findRepeated) &&
                findRepeated.configurationType !== 'alternate' &&
                item.configurationType !== 'alternate' &&
                !sponsorships.find(row => row.id === findRepeated.id)
            ) {
                if (findRepeated.sponsorBy) {
                    sponsorships.push(findRepeated);
                } else {
                    sponsorships.push(item);
                }
            }
        }
    });

    return sponsorships;
};

/**
 * Generate Mineral Package name from sku packages
 *
 * @param   {Array}    packages
 * @return  {Object}
 */
export const generatePackageName = (packages = []) => {
    const packagesName = packages
        .map(({ name }) => name)
        .filter((name, index, self) => self.indexOf(name) === index)
        .sort();
    return packagesName.length ? packagesName.join(', ') : '-';
};

/**
 * Generate SKU Package name sku packages
 *
 * @param   {Array}    packages
 * @param   {Array}    ownerPackage
 * @return  {Object}
 */
export const generateSKUPackageName = (packages = [], ownerPackage = []) => {
    const skuPackagesName = packages
        .map(({ name }) => name)
        .filter((name, index, self) => self.indexOf(name) === index)
        .sort();
    const packIntersection = ownerPackage.filter(value => skuPackagesName.includes(value));
    const skuPack = [];
    if (packIntersection.length) {
        return packIntersection.sort().join(', ');
    } else {
        skuPack.push('-');
    }
    return skuPack.join(', ');
};
